module.exports = __webpack_public_path__ + "img/premios.10e199b2.png";